import React, { Fragment, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/opacity.css';

import './DiscountProgramProduct.scss';
import { link } from '../../helpers/link';
import icons from '../../shared/assets/icons';
import sendEvent from '../../helpers/tracking';
import { getString } from '../../helpers/styles';

const { ShoppingCart, Heart } = icons;

export default function DiscountProgramProduct(props) {
  const isMiniature = props.view === 'miniature';

  const product = props.product.campaign || props.product;

  const isAddedToWishList =
    props.user &&
    props.user.wishlistEntries &&
    !!props.user.wishlistEntries.find(
      (item) => item.campaign.xuid === product.xuid
    );

  return (
    <section
      className="discountProgramProduct"
      id={getString('discountProgramProduct_full_sized', !isMiniature)}
    >
      {isMiniature ? (
        <MiniatureView
          {...props}
          product={product}
          isAddedToWishList={isAddedToWishList}
        />
      ) : (
        <FullSizeView
          {...props}
          product={product}
          isAddedToWishList={isAddedToWishList}
        />
      )}
    </section>
  );
}

function MiniatureView(props) {
  const { xuid, imageUrl, categories, name, partner, targetUrl } =
    props.product;

  return (
    <Fragment>
      <h4>Populairste product</h4>

      <div className="discountProgramProduct_title">
        <p>{name}</p>
      </div>

      <div className="discountProgramProduct_image">
        <a
          onClick={() =>
            props.eventTrackingCodes && sendEvent(...props.eventTrackingCodes)
          }
          href={targetUrl || `/discount-program-offer?product=${xuid}`}
        >
          <LazyLoadImage
            src={imageUrl}
            effect="opacity"
            alt="product-image"
            visibleByDefault={props.visibleByDefault}
          />
        </a>

        {categories && categories.length && (
          <p>{categories[0].category.name}</p>
        )}

        {!props.hideWishListIcon && (
          <span
            onClick={() => setWishlist(xuid, props)}
            className={getString(
              'discountProgramProduct_added',
              props.isAddedToWishList
            )}
          >
            <Heart />
          </span>
        )}
      </div>

      {partner && (
        <div className="discountProgramProduct_partner">
          <div className="discountProgramProduct_partner_image">
            <img src={partner.imageUrl} alt="partner-image" />
          </div>

          <a target="_blank" href={partner.website} rel="noopener noreferrer">
            <span>{partner.displayName}</span>
          </a>

          {link(
            <button
              onClick={() =>
                props.eventTrackingCodes &&
                sendEvent(...props.eventTrackingCodes)
              }
            >
              Bekijken
            </button>,
            targetUrl || `/discount-program-offer?product=${xuid}`
          )}
        </div>
      )}
    </Fragment>
  );
}

function FullSizeView(props) {
  const {
    xuid,
    name,
    partner,
    benefits,
    imageUrl,
    categories,
    descriptionHtml,
    code: productCode
  } = props.product;

  const [code, showCode] = useState(false);

  return (
    <Fragment>
      <div className="discountProgramProduct_content">
        <p className="discountProgramProduct_title">{name}</p>

        {partner && (
          <div className="discountProgramProduct_partner">
            <div className="discountProgramProduct_partner_image">
              <img src={partner.imageUrl} alt="partner-image" />

              <a
                target="_blank"
                href={partner.website}
                rel="noopener noreferrer"
              >
                <span>{partner.displayName}</span>
              </a>
            </div>

            {categories && categories.length && (
              <p>{categories[0].category.name}</p>
            )}
          </div>
        )}

        <img
          alt="product-image"
          src={imageUrl}
          className="discountProgramProduct_image"
        />

        {code ? (
          <div className="discountProgramProduct_code">{productCode}</div>
        ) : (
          <Fragment>
            <button
              onClick={() => {
                revealCode(props);

                sendEvent('fvp', 'fvp-offer', 'fvp-offer-bekijk');
              }}
            >
              <ShoppingCart /> Bekijk voordeel
            </button>

            <button
              onClick={() => {
                setWishlist(xuid, props);

                sendEvent('fvp', 'fvp-offer', 'fvp-offer-fav');
              }}
              className={getString(
                'discountProgramProduct_added',
                props.isAddedToWishList
              )}
            >
              <Heart /> Op verlanglijstje
            </button>
          </Fragment>
        )}

        <div className="discountProgramProduct_description">
          <p dangerouslySetInnerHTML={{ __html: descriptionHtml }} />
        </div>

        {benefits && (
          <div className="discountProgramProduct_benefits">
            <p>Voordelen van dit product</p>

            <ul>
              {benefits
                .split('-')
                .slice(1)
                .map((item, idx) => (
                  <li key={idx}>
                    <span>&#65291;</span>
                    <div>{item}</div>
                  </li>
                ))}
            </ul>
          </div>
        )}
      </div>
    </Fragment>
  );

  function revealCode(props) {
    if (!props.user.username)
      return props.showLoginPopup(`Je bent één stap verwijderd van
        het bekijken van de kortingscode. Log in met je account om
        de code te zien`);

    if (props.user.username && !props.user.premium)
      return props.showDiscountProgramPopup(true);

    showCode(true);
  }
}

function setWishlist(id, props) {
  const { user, loginUrl, addWishlist, removeWishlist, isAddedToWishList } =
    props;

  if (!user.username) return (location.href = loginUrl);

  if (isAddedToWishList)
    removeWishlist({ variables: { recordKey: id }, skip: !id });
  else addWishlist({ variables: { recordKey: id }, skip: !id });
}
